/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import { Map } from 'immutable';
import { denormalize } from 'normalizr';
import * as schemas from 'data/utils/schemas';
import {
  loadingProgress,
  listLoadingProgress,
  itemsPagination,
  usersKpiloadingProgress,
} from 'data/reducers/admin/users';

import createImmutableEqualSelector from '../../utils/immutable-selector';

const getState = (state) => state.adminUsers;

export const getEntities = (state) => getState(state).get('entities');

export const getItemsList = createImmutableEqualSelector(getEntities, getState, (users, state) =>
  denormalize(itemsPagination.getPageItems(state), [schemas.user], new Map({ users })),
);

export const getItemsTotal = (state) => itemsPagination.getTotalItems(getState(state));
export const getItemsPerPage = (state) => itemsPagination.getItemsPerPage(getState(state));

export const getItemsListLoaded = (state) => listLoadingProgress.getLoaded(getState(state));
export const getItemsListLoading = (state) => listLoadingProgress.getLoading(getState(state));
export const getItemsListLoadFailed = (state) => listLoadingProgress.getLoadFailed(getState(state));

export const getItemLoaded = (state) => loadingProgress.getLoaded(getState(state));
export const getItemLoading = (state) => loadingProgress.getLoading(getState(state));
export const getItemLoadFailed = (state) => loadingProgress.getLoadFailed(getState(state));

export const getItem = (state, id) => getEntities(state).get(id);

export const getUsersKpi = (state) => getState(state).get('usersKpi');
export const getKpiLoaded = (state) => usersKpiloadingProgress.getLoaded(getState(state));
export const getKpiLoading = (state) => usersKpiloadingProgress.getLoading(getState(state));
export const getKpiLoadFailed = (state) => usersKpiloadingProgress.getLoadFailed(getState(state));
